import CookieService from "./cookieService";

export default class AppService {

    static cookieConsts = {
        userHasRegistered: 'aroreg',
        appInstallRejected: 'aroapprejected',
        showIOSInstallInstr: 'true'
    }

    static isIOS() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }

    static isIOSChrome() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent) && /crios/.test(userAgent);
    }

    static isPWAInstalled() {
        // Non-IOS
        return new Promise((resolve, reject) => {
            const currentHost = window.location.hostname;

            navigator.getInstalledRelatedApps().then(relatedApps => {
                if (relatedApps && relatedApps.find(x => x.webapp.includes(currentHost)) != null) {
                    resolve(true);
                }

                resolve(false);
            }).catch(() => {
                reject();
            });
        });
    }

    static appIsInstalled() {
        return new Promise((resolve, reject) => {
            const isInWebAppiOS = (window.navigator.standalone == true);
            const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);

            if (isInWebAppiOS && isInWebAppiOS === true || isInWebAppChrome && isInWebAppChrome === true) {
                resolve(true);
            }

            navigator.serviceWorker.getRegistrations().then((registrations) => {
                if (registrations && registrations.length > 0) {
                    const appRegistration = registrations.find(x => x.active && x.active.scriptURL.endsWith('/service-worker.js'));

                    if (appRegistration) {
                        resolve(true);
                    }
                }

                resolve(false);
                CookieService.delete(AppService.cookieConsts.showIOSInstallInstr);
            }).catch(() => {
                reject();
            });
        });
    }

    static appIsRunningStandalone() {
        const isInWebAppiOS = (window.navigator.standalone == true);
        const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);

        return isInWebAppiOS === true || isInWebAppChrome == true;
    }

    static install(successCallbackFn, errorCallbackFn) {
        navigator.serviceWorker.register('/service-worker.js').then(() => {
            if (successCallbackFn) {
                successCallbackFn();
            }
        }).catch(error => {
            alert('Aro app not installed');

            if (errorCallbackFn) {
                errorCallbackFn();
            }
        });
    }

    static uninstall(successCallbackFn, errorCallbackFn) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            const appRegistration = registrations.find(x => x.active && x.active.scriptURL.endsWith('/service-worker.js'));

            if (appRegistration) {
                appRegistration.unregister().then(uninstalled => {
                    if (uninstalled) {
                        // Now remove any caches
                        if ('caches' in window) {
                            caches.keys().then((cacheNames) => {
                                cacheNames.forEach((cacheName) => {
                                    caches.delete(cacheName).then((success) => {
                                        if (success) {
                                            console.log(`Cache ${cacheName} deleted`);
                                        } else {
                                            console.log(`Cache ${cacheName} could not be deleted`);
                                        }
                                    });
                                });
                            }).catch((error) => {
                                console.error('Error getting cache keys:', error);
                            });
                        }

                        if (successCallbackFn) {
                            successCallbackFn();
                        }

                        CookieService.delete(this.cookieConsts.showIOSInstallInstr);
                        CookieService.delete(this.cookieConsts.appInstallRejected);
                    }
                    else {
                        alert('Error when trying to un-install Aro, please re-try');
                        if (errorCallbackFn) {
                            errorCallbackFn();
                        }
                    }
                });
            }
            else {
                alert('Aro app not installed');
            }
        }).catch(error => {
            alert('Aro app not uninstalled');

            if (errorCallbackFn) {
                errorCallbackFn();
            }
        });
    }
}